import React from 'react'
import PageHeader from '../PageHeader'
import GridItem from '../GridItem'
import SliderContainer from '../SliderContainer'
import MyGallery from '../MyGallery'

export default class Building extends React.Component {
  render() {
    const { content } = this.props
    const gridItems = content.acf.box_section.map(a => (
      <GridItem data={a} key={a.title} />
    ))

    const isEnglish = window.location.pathname.indexOf('/en/') > -1

    return (
      <div className="page-content page-building">
        <PageHeader image={content.thumbnail} />
        <div className="col-layout text-section-cols">
          <div className="col">
            <h2>{content.post_title ? content.post_title : ''}</h2>
          </div>
          <div
            className="col"
            dangerouslySetInnerHTML={{
              __html: content.post_content
                ? `<p>${content.post_content}</p>`
                : ''
            }}
          />
        </div>
        <div className="col-3 grid-item-container">{gridItems}</div>
        <SliderContainer
          content={content.acf.slideshow}
          continues={!(content.acf.slideshow.length <= 2)}
          position="bottom-right"
        />
        <section className="gallery">
          <MyGallery
            galleryTitle={isEnglish ? 'Gallery' : 'Galleri'}
            photoArray={content.acf.images.map(a => ({
              src: a.sizes.large,
              width: a.sizes['large-width'],
              height: a.sizes['large-height']
            }))}
          />
          <p>
            <a href={isEnglish ? '/gallery/' : '/galleri/'}>
              {content.acf.gallery_link_text}
            </a>
          </p>
        </section>
        <div className="pembroke-last-section">
          <section className="about-pembroke">
            <div
              dangerouslySetInnerHTML={{
                __html: content.acf.content ? content.acf.content : ''
              }}
            />
            <div>
              <img src={content.acf.logotype.url} alt="logo" />
            </div>
          </section>
          <div
            className="pembroke-logo"
            style={{
              backgroundImage: `url(${content.acf.pembroke_logo})`
            }}
          />
        </div>
      </div>
    )
  }
}
